import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from './../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('description'),
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('valid_from'),
			fieldsMap.get('valid_to'),
		]
	},
	fieldsMap.get('week_days'),
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('time_from'),
			fieldsMap.get('time_to'),
			fieldsMap.get('time_interval_minutes')
		]
	}
];

const config: IFormConfig = { 
	title: 'Crea Disponibilità',
	editTitle: 'Modifica Disponibilità',
	fields: formFields 
};

export default config;